if (!customElements.get('product-purchase')) {
  class ProductPurchase extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-product-purchase-row]');
      this.sentinel = this.querySelector('[data-product-purchase-sentinel]');

      if (!this.row || !this.sentinel) return;
      if (this.closest('quick-add-modal')) return;

      const breakpoint = Number(this.dataset.mobileBreakpoint) || 749;
      this.mobileMedia = window.matchMedia(`(max-width: ${breakpoint}px)`);
      this.handleViewportChange = this.update.bind(this);

      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.addEventListener('change', this.handleViewportChange);
      } else {
        this.mobileMedia.addListener(this.handleViewportChange);
      }

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.sentinelEntry = entry;
          this.update();
        },
        { threshold: [0, 1] }
      );
      this.observer.observe(this.sentinel);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateStickyHeight());
        this.resizeObserver.observe(this.row);
      }

      this.updateStickyHeight();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();

      if (this.mobileMedia?.removeEventListener) {
        this.mobileMedia.removeEventListener('change', this.handleViewportChange);
      } else {
        this.mobileMedia?.removeListener(this.handleViewportChange);
      }

      this.setSticky(false);
    }

    update() {
      const sentinelHasPassed = this.sentinelEntry
        ? this.sentinelEntry.boundingClientRect.bottom < 0
        : this.sentinel.getBoundingClientRect().bottom < 0;

      this.setSticky(this.mobileMedia.matches && sentinelHasPassed);
    }

    setSticky(isSticky) {
      if (this.isSticky === isSticky) return;

      this.isSticky = isSticky;
      this.classList.toggle('is-sticky', isSticky);
      document.documentElement.classList.toggle('product-purchase-sticky-active', isSticky);

      if (isSticky) this.updateStickyHeight();
    }

    updateStickyHeight() {
      if (!this.row) return;

      document.documentElement.style.setProperty(
        '--product-purchase-sticky-height',
        `${Math.ceil(this.row.getBoundingClientRect().height)}px`
      );
    }
  }

  customElements.define('product-purchase', ProductPurchase);
}
